import GoalError from './GoalError';
class MonthlyInvestmentCapacityMustBeAnInteger extends GoalError {
    constructor(options) {
        super('Available funds are not an integer when the goal type is FUNDS', options);
    }
}
export default MonthlyInvestmentCapacityMustBeAnInteger;
